<template>
  <section class="bq-box" :class="{ mobile: isMobile }">
    <div class="bq-box-hd" v-if="title">
      <header>
        <h3 :style="{ color: `${color}` }">
          <span>{{ title }}</span>
        </h3>
        <p class="bq-box-desc" v-if="desc">{{ desc }}</p>
      </header>

      <div class="bq-box-extra" v-if="extra.title && extra.path">
        <a :href="extra.path" :title="extra.title">{{ extra.title }}</a>
      </div>
    </div>

    <!-- 内容插槽 -->
    <slot></slot>
  </section>
</template>

<script>
import { isWirelessDevice } from '../../../utils/utils';
import { project_env } from '../../../defaultSettings';

export default {
  name: 'BQBox',

  props: {
    title: String,
    desc: String,
    color: String,
    extra: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },

  data() {
    return {
      isMobile: false,
      project_env,
    };
  },

  created() {
    this.isMobile = isWirelessDevice();
  },
};
</script>

<style lang="less" scoped>
@import './index.less';
</style>
